{
  "fleetSizeQuestion": "How many drivers does your fleet have today?",
  "fleetSizeHint": "Just to understand your operation — you'll choose how many licenses to activate in the next step.",
  "fleetSizeOptionDrivers": "{{range}} drivers",
  "fleetSizeSaveError": "Could not save. Please try again.",
  "productQuestion": "Which product do you want to activate?",
  "productHint": "Choose one product now — you can mix a different combination later in the dashboard.",
  "productOption_hours": "Hours",
  "productOption_hoursDescription": "Logs schedules, breaks and rest periods, supporting compliance and replacing manual records.",
  "productOption_gps": "GPS",
  "productOption_gpsDescription": "Tracks vehicles in real time to help manage operations and respond to unexpected events.",
  "productOption_combo": "Hours + GPS (Combo)",
  "productOption_comboDescription": "Combines hours tracking and real-time location to manage compliance and operations in one service.",
  "licensesQuestion": "How many licenses do you want to activate now?",
  "licensesHint": "You can activate fewer licenses than drivers — and add more at any time.",
  "licensesSuggested": "Suggestion for {{range}} drivers: {{count}}",
  "licensesInvalid": "Enter a number between 1 and {{max}}.",
  "licensesInputLabel": "Number of licenses",
  "licensesIncrease": "Increase licenses",
  "licensesDecrease": "Decrease licenses",
  "licensesTrialNoCard": "{{days}}-day free trial — no card needed to start.",
  "trialCardUpfront": "{{days}}-day free trial — card requested now, only charged when the trial ends.",
  "licensesAnswer": "{{count}} licenses",
  "startFreeTrial": "Start free trial",
  "loading": "Loading…",
  "stripeLoadErrorTitle": "Could not load secure payment",
  "stripeLoadErrorMessage": "An ad blocker, your network or the Stripe CDN may have blocked loading. Try again or contact support to complete your purchase.",
  "tryAgain": "Try again",
  "contactSupport": "Contact support",
  "gpsContractAcceptErrorTitle": "Could not accept the contract",
  "gpsContractAcceptErrorMessage": "An error occurred while registering the GPS contract acceptance. Try again; if it persists, contact support.",
  "gpsContractLoadError": "Could not load the GPS contract. Try again.",
  "gpsContractVersionChangedTitle": "The contract was updated",
  "gpsContractVersionChangedMessage": "A new version of the GPS contract was published. Read the version shown before accepting.",
  "onboardingWelcomeTitle": "Welcome to our app!",
  "onboardingWelcomeDescription": "Let's set up some important information before we get started. This will help us personalize your experience.",
  "onboardingTitle": "Initial Setup",
  "continue": "Continue",
  "employmentTitle": "Employment Information",
  "loadingEmploymentInfo": "Loading employment information...",
  "employmentDataFound": "We found your employment information:",
  "edit": "Edit",
  "retry": "Retry",
  "networkError": "We couldn't load your employment information. Check your internet connection and try again.",
  "employmentFormIntro": "Please provide your employment information:",
  "companyName": "Company Name",
  "companyNipc": "Company NIF/NIPC",
  "nipcError": "NIF/NIPC must contain 9 digits",
  "companyEmail": "Company Email",
  "companyPhone": "Company Phone",
  "payerQuestion": "Who pays for the work license?",
  "payerCompany": "My company pays",
  "payerSelf": "I pay for my own license",
  "payerRequired": "Choose who pays.",
  "permissionsTitle": "App Permissions",
  "permissionsDescription": "To provide the best experience, we need the following permissions:",
  "notificationsPermission": "Notifications",
  "notificationsPermissionMessage": "To receive notifications, you need to enable this permission in your device settings.",
  "notificationsPermissionTitle": "Notifications",
  "notificationsPermissionDescription": "To receive alerts and important information",
  "locationPermission": "Location",
  "locationPermissionMessage": "To use your current location, you need to enable this permission in your device settings.",
  "locationForegroundPermissionTitle": "Location (Foreground)",
  "locationForegroundPermissionDescription": "To show your current location on the map",
  "backgroundLocationPermission": "Location (Background)",
  "backgroundLocationPermissionMessage": "To use your location in the background, you need to enable this permission in your device settings. Be sure to select 'Allow all the time' for the app to function correctly.",
  "locationBackgroundError": "Permission required",
  "locationBackgroundErrorMessage": "You need to enable foreground location before enabling background location.",
  "locationBackgroundPermissionImportant": "Important: To receive notifications when you're stopped at the same location for a while, you need to select 'Allow all the time' in your device's location settings.",
  "finish": "Finish",
  "ownerWelcomeTitle": "Experience the ultimate fleet management solution!",
  "ownerWelcomeDescription": "Control working hours and track vehicles in real time with GPS. Optimize operations and ensure compliance effortlessly.",
  "ownerFeaturesTitle": "Key Features",
  "ownerFeatureLiveTracking": "GPS device tracking with live map",
  "ownerFeatureReports": "Automatic hour logging and compliance reports",
  "ownerFeatureLicense": "Separate licenses for Hours and GPS",
  "planType": {
    "hours": "Hours",
    "gps": "GPS",
    "combo": "Combo (Hours + GPS)"
  },
  "ownerTrialButton": "Start Your Free Trial",
  "trialModalTitle": "Start your 7-day free trial",
  "trialModalDescription": "Enter your payment details to start a 7-day trial. You won't be charged until it ends.",
  "trialError": "An error occurred",
  "trialProcessing": "Processing...",
  "trialStartButton": "Start Trial",
  "paymentModalTitle": "Complete your purchase",
  "completePurchase": "Complete purchase",
  "paymentProcessing": "Your payment is processing. We will update your subscription when it is completed.",
  "paymentError": "An error occurred. Please try again.",
  "paymentErrors": {
    "noStoredPlan": "We could not recover the selected plan.",
    "trialSubscriptionFailed": "We could not start the free trial.",
    "subscriptionIdMissing": "We could not identify the subscription.",
    "confirmPaymentFailed": "We could not confirm the payment."
  },
  "supportEmailSubject": "AllDrivers - Stripe checkout unavailable",
  "errorOpeningPortal": "Could not open the Stripe portal.",
  "noPlansAvailable": "No plans available",
  "manageInStripe": "Manage in Stripe",
  "interval": {
    "month": "month",
    "year": "year"
  },
  "buyLicense": {
    "setupFee": "Setup fee",
    "once": "one time",
    "monthlyAmount": "Monthly amount",
    "selectQuantity": "How many licenses do you need?",
    "quantity": "Number of licenses",
    "summary": "Order summary",
    "plan": "Plan",
    "licenses": "Licenses",
    "total": "Total",
    "totalFirstInvoice": "Total (first invoice)"
  },
  "checkoutReturn": {
    "checkingTitle": "Confirming payment",
    "checkingDescription": "We are checking the checkout result.",
    "successTitle": "Payment successful!",
    "successDescription": "Your license is active and you can access your dashboard.",
    "pendingTitle": "Processing payment",
    "pendingDescription": "We are confirming your payment. It may take a few moments — refresh shortly and contact support if the license does not become active.",
    "canceledTitle": "Payment canceled",
    "canceledDescription": "You canceled checkout. You can activate your license whenever you want.",
    "retry": "Try again",
    "errorTitle": "Could not confirm payment",
    "errorDescription": "We could not validate the checkout return. If you have already paid, wait a few minutes or contact support.",
    "returnToDashboard": "Go to dashboard"
  },
  "retryPayment": "Try Again",
  "errorFetchingPlans": "Error fetching subscription plans",
  "reviewSetupTotal": "Total setup charged once: {{total}}",
  "licensesShort": "licenses",
  "eligibilityUnavailable": "Eligibility could not be validated.",
  "processing": "Processing...",
  "trialDescription": "You will be redirected to our secure payment page to start your trial.",
  "paymentDescription": "You will be redirected to our secure payment page to complete your purchase.",
  "cancel": "Cancel",
  "continueToTrial": "Continue to trial",
  "ownerDashboard": {
    "choosePlan": "Choose your plan",
    "save10Percent": "Save 10% with the annual plan",
    "14daystrial": "7-day free trial",
    "startTrial": "Start 7-day trial",
    "buyNow": "Buy Now",
    "activeDrivers": "Active Drivers",
    "hoursLicenses": "Hours Licenses",
    "availableHoursLicenses": "Available Hours",
    "gpsLicenses": "GPS Licenses",
    "availableGpsLicenses": "Available GPS",
    "companyStats": "Company Statistics",
    "dau": "Daily Active Drivers",
    "mau": "Monthly Active Drivers",
    "employmentsVsLicenses": "Active Employments vs Driver Licenses",
    "unassignedDrivers": "Unassigned Active Drivers",
    "last12Periods": "last 12 periods",
    "last6Weeks": "last 6 weeks",
    "unpaidInvoices": "Unpaid Invoices",
    "oldestVehicles": "Top Oldest Vehicles",
    "highOdometer": "Top High Odometer",
    "invitations": "Invitations (7/30 days)",
    "sentAcceptedExpired": "sent/accepted/expired",
    "inviteDriver": "Invite Driver",
    "inviteDriverDesc": "Send invitation to new drivers",
    "buyLicenses": "Buy Licenses",
    "buyLicensesDesc": "Purchase additional driver licenses",
    "today": "Today",
    "average": "Average",
    "latest": "Latest",
    "last12Days": "last 12 days",
    "last12Months": "last 12 months"
  },
  "planQuestion": "Do you prefer monthly or annual billing?",
  "planHint": "Prices and trial eligibility come from the current catalog. Choose monthly or annual.",
  "planMonthlyTitle": "Monthly",
  "planAnnualTitle": "Annual",
  "selectPlan": "Select",
  "planMonthlyValue": "{{price}} per license/month",
  "planAnnualValue": "{{price}} per license/year",
  "planTrialEligible": "{{days}}-day free trial, no card required.",
  "planSetupUnit": "Setup: {{price}} per vehicle, charged once.",
  "planAnnualSaving": "Save {{save}} per license/year.",
  "planEligibilityLoading": "Validating plan conditions…",
  "planCycleUnavailable": "Unavailable in the current catalog.",
  "planUnavailable": "This product is temporarily unavailable because the catalog does not contain all required conditions.",
  "reviewSelection": "Review values",
  "reviewTitle": "Summary before confirmation",
  "reviewProduct": "Product: {{product}}",
  "reviewRecurringCalculation": "{{quantity}} × {{unit}} = {{total}} recurring per {{period}}.",
  "reviewSetupCalculation": "{{quantity}} × {{unit}} = {{total}} setup, charged once.",
  "reviewAnnualSaving": "Save {{unitSave}} per license ({{totalSave}} total) compared with 12 monthly payments.",
  "reviewChargedToday": "Total charged today: {{total}}.",
  "reviewNextChargeAfterTrial": "Next charge: {{total}} after {{days}} days; then every month.",
  "reviewNextCharge": "Next recurring charge: {{total}} next {{period}}.",
  "periodMonth": "month",
  "periodYear": "year",
  "vatIncluded": "VAT included.",
  "startTrialCta": "Start free trial",
  "continueToPayment": "Continue to payment",
  "checkoutSelectionInvalid": "The chat selection does not match the current catalog. Return to chat and choose again.",
  "checkoutEligibilityUnavailable": "This selection's eligibility could not be validated. Try again.",
  "checkoutSelectionDetails": "{{licenses}} licenses · {{billing}} · {{price}} per license",
  "checkoutSetupFee": "Setup: {{price}} per vehicle, charged once.",
  "returnToChat": "Return to chat",
  "purchaseSuccess": "Purchase started successfully.",
  "subscriptionError": "The subscription could not be started.",
  "purchaseFailed": "The purchase could not be completed. Try again.",
  "purchaseCancelled": "Payment canceled or not confirmed. Try again or return to chat.",
  "paymentSelectionInvalid": "The checkout selection is invalid.",
  "billing": {
    "monthly": "monthly",
    "annual": "annual"
  },
  "common": {
    "invite": "Invite",
    "buy": "Buy",
    "knowMore": "Know More"
  },
  "productOption_hoursShort": "Hours and rest logging.",
  "productOption_gpsShort": "Real-time vehicle location.",
  "productOption_comboShort": "Hours and GPS in one service.",
  "productCardPricing": "{{monthly}}/mo · {{annualMonthly}}/mo billed yearly",
  "productCardPricingMonthlyOnly": "{{monthly}}/mo",
  "productCardAnnualBilled": "Billed yearly at {{total}}",
  "changeProduct": "Change product",
  "viewDetails": "View details",
  "hideDetails": "Hide details",
  "driverSingleLicense": "1 licence — yours.",
  "referralAttribution": "Referral: {{partner}}",
  "registrationOnlyCta": "Continue with registration only",
  "registrationOnlyHint": "Finish signing up without activating licenses. You can buy licenses later from the dashboard.",
  "registrationOnlyError": "We could not finish your registration. Please try again.",
  "gpsContractDeclinedMessage": "You didn't accept the GPS contract, so nothing was charged. GPS needs the contract; you can continue with Hours only.",
  "gpsContractDeclinedHoursOnly": "Continue with Hours only",
  "gpsContractDeclinedReview": "Review the contract",
  "gpsContractDeclinedSwitchError": "Couldn't switch to Hours. Please try again."
}
